export const MOBILE_NAME = "webviewer";
export const APP_VERSION = "1.0.0";
export const TOKEN_TYPE = "web";
